// extracted by mini-css-extract-plugin
export default {"root":"_1NuRy","large":"_3j5CI","medium":"eys2H","small":"_2k9mM","daily-deviation":"_1PgXx","dailyDeviation":"_1PgXx","hype":"fM2KD","stash":"_4kSXY"};